import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "../App.scss";

const images = Array.from({ length: 66 }, (_, i) =>
  require(`../assets/portfolio/sttl_img_${i + 1}.jpeg`),
);

const PortfolioGallery = () => {
  const [modalImg, setModalImg] = useState(null);

  return (
    <div className="portfolio-section">
      <div className="portfolio-title">Visual Showcase</div>
      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={3}
        navigation
        pagination={false}
        className="swiper"
        breakpoints={{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {images.map((src, idx) => (
          <SwiperSlide key={idx}>
            <img
              src={src}
              alt={`Portfolio ${idx + 1}`}
              onClick={() => setModalImg(src)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {modalImg && (
        <div className="modal-bg" onClick={() => setModalImg(null)}>
          <img src={modalImg} alt="Enlarged" className="modal-img" />
        </div>
      )}
    </div>
  );
};

export default PortfolioGallery;
